import { TResourceValue } from "../../../../services/valuesManager/valuesManager"
import { defaultRxInformationState, RxInformationState } from "../prescriptionInformation/PrescriptionInformation";


export type TPhysicalTherapyDropdownValues = {
    productCategory?: TResourceValue,
    products?: TResourceValue[],
    bodyParts?: TResourceValue[],
    bodySides?: TResourceValue[],
    injuryTypes?: TResourceValue[],
};

export interface IPhysicalTherapyState extends RxInformationState {
    therapyType?: TResourceValue,
    otherDescription: string,
    bodyPart?: TResourceValue,
    bodySide?: TResourceValue,
    injuryType?: TResourceValue,
    surgeryDate?: Date,
    surgeryDateString?: string,
    rxCertificationNumber: string,
    rxCertificationExpirationDate?: Date,
    rxCertificationExpirationDateString?: string,
    therapyPrescription: string,
    isRush: boolean,
    dropdownValues: TPhysicalTherapyDropdownValues;
    productsLoaded: boolean;
}

export const defaultPhysicalTherapyState: IPhysicalTherapyState = {
    otherDescription: "",
    rxCertificationNumber: "",
    therapyPrescription: "",
    isRush: false,
    errors: [],
    dropdownValues: {},
    productsLoaded: false,
    ...defaultRxInformationState,
}